/*
  didYouMean.js copyright (c) 2013-2014 Dave Porter.

  [Available on GitHub](https://github.com/dcporter/didyoumean.js).

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License
  [here](http://www.apache.org/licenses/LICENSE-2.0).

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
*/
(function(){"use strict";function e(t,r,i){if(!t)return null;if(!e.caseSensitive){t=t.toLowerCase()}var s=e.threshold===null?null:e.threshold*t.length,o=e.thresholdAbsolute,u;if(s!==null&&o!==null)u=Math.min(s,o);else if(s!==null)u=s;else if(o!==null)u=o;else u=null;var a,f,l,c,h,p=r.length;for(h=0;h<p;h++){f=r[h];if(i){f=f[i]}if(!f){continue}if(!e.caseSensitive){l=f.toLowerCase()}else{l=f}c=n(t,l,u);if(u===null||c<u){u=c;if(i&&e.returnWinningObject)a=r[h];else a=f;if(e.returnFirstMatch)return a}}return a||e.nullResultValue}function n(e,n,r){r=r||r===0?r:t;var i=e.length;var s=n.length;if(i===0)return Math.min(r+1,s);if(s===0)return Math.min(r+1,i);if(Math.abs(i-s)>r)return r+1;var o=[],u,a,f,l,c;for(u=0;u<=s;u++){o[u]=[u]}for(a=0;a<=i;a++){o[0][a]=a}for(u=1;u<=s;u++){f=t;l=1;if(u>r)l=u-r;c=s+1;if(c>r+u)c=r+u;for(a=1;a<=i;a++){if(a<l||a>c){o[u][a]=r+1}else{if(n.charAt(u-1)===e.charAt(a-1)){o[u][a]=o[u-1][a-1]}else{o[u][a]=Math.min(o[u-1][a-1]+1,Math.min(o[u][a-1]+1,o[u-1][a]+1))}}if(o[u][a]<f)f=o[u][a]}if(f>r)return r+1}return o[s][i]}e.threshold=.4;e.thresholdAbsolute=20;e.caseSensitive=false;e.nullResultValue=null;e.returnWinningObject=null;e.returnFirstMatch=false;if(typeof module!=="undefined"&&module.exports){module.exports=e}else{window.didYouMean=e}var t=Math.pow(2,32)-1})();

function maybeYouMeant(query, list){
  var searchTerm = query;
  var searchList = list;
  didYouMean.threshold = 0.7;
  var recommendedSearch = didYouMean(searchTerm, searchList);
  // console.log(recommendedSearch)
  if (recommendedSearch != null) {
    $('.didyoumean').fadeIn();
    $('.other-results').html("<a href='/search/?q="+recommendedSearch+"'>"+recommendedSearch+"</a>")
  } else {
    $('.didyoumean').fadeOut();
  }
}
if ($('.search-page-results-error').length) {
  checkForTypos($('#search-form--page input[type="text"]').val());
}

/* ---------------------------------------------
SEARCH
------------------------------------------------ */
$('.js-open-search-bar').on('click', function (e) {
e.preventDefault();
openSearch();
});

$('.js-close-search-bar').on('click', function () {
closeSearch();
});


$(window).on('resize', function(){
var siteHeaderHeight = $('.site-header').height();
$('.open-search-bar .search-bar').css('transform','translateY('+siteHeaderHeight+'px)');
})

// ----------------------------
// OPEN AND CLOSE THE SEARCH BAR
function openSearch () {
var siteHeaderHeight = $('.site-header').height();
$('body').addClass('open-search-bar');
$('.overlay').addClass('active');
$('.search-bar').css('transform','translateY('+siteHeaderHeight+'px)');

setTimeout(function () {
  $('.js-search').focus();
}, 100);

// CLOSE SEARCH IF USER SCROLLS OUTSIDE
if ($(window).width() >= 991) {
  $(window).on('scroll.closeSearch', function () {
    closeSearch();
    $(window).off('scroll.closeSearch');
    $('body').off('click.closeSearchBar');
    $('.overlay').removeClass('active');
  });
}

// CLOSE SEARCH IF USER CLICKS OUTSIDE
$('body').on('click.closeSearchBar', function (e) {
  if ($(e.target).closest('.js-search-bar').length == 0 && $(e.target).closest('.js-open-search-bar').length == 0) {
    closeSearch();
    $(window).off('scroll.closeSearch');
    $('body').off('click.closeSearchBar');
    $('.overlay').removeClass('active');
  }
});
}

function closeSearch () {
var siteHeaderHeight = $('.site-header').height();
$('body').removeClass('open-search-bar');
$('.overlay').removeClass('active');
$('.search-bar').css('transform','translateY(-'+siteHeaderHeight+'px)');
clearSearch();
}

function clearSearch () {
resetSearchBar();
toggleSearchButton(false);
$('.js-search-dropdown').removeClass('active');
$('input[type="search"]').val('');
$('.didyoumean').fadeOut();
}

// ----------------------------
// RESULTS INTERACTIONS
function showResultsDropdown () {
$('.js-search-dropdown').addClass('active');
}

function toggleSearchButton (resultsFound) {
if (resultsFound == true) {
  $('.js-search-bar .search-submit-btn').addClass('active');
} else {
  $('.js-search-bar .search-submit-btn').removeClass('active');
}
}

function submitSearch () {

}

// ----------------------------
// EMPTY STATE
function showEmptySearchState (query) {
$('.js-empty-state').fadeIn();
$('.js-empty-state span').html('Sorry, nothing found for ' + query + '.');
$('.js-results-list').hide();
}

function resetSearchBar () {
// FIX JUMPING ISSUE
$('.js-results-products, .js-results-pages, .js-results-posts').hide();
$('.js-results-products, .js-results-pages, .js-results-posts').find('.js-list').html('');
}

function checkForSynonyms (query) {
var synonymList = $('#search-synonyms').data('search-synonyms').split(',');
var matchFound = false;

for (var i = 0; i < synonymList.length; i++) {
  var synonym = synonymList[i].trim();
  if (synonym.startsWith(query)) {
    searchFormTerm(synonym.split(':')[1].trim());
    // Change term that will be submitted when form is submitted
    $('#search-bar').val(synonym.split(':')[1].trim());
    matchFound = true;
    break;
  }
}

return matchFound;

}

function checkForTypos (query) {
var list = [];
var typoList = $('#search-typos').data('search-typos').split(',');
var matchFound = false;
var list = [];
if (typoList.length) {
  for (var i = 0; i < typoList.length; i++) {
    var typo = typoList[i].trim();
    list.push(typo);
  }
  maybeYouMeant(query, list);
}
}

function showSearchResults (searchResults, parentWrapper, type) {
// PRODUCTS AND PAGES
if (searchResults.length > 0) {
  $(parentWrapper).show();
  for (var i = 0; i < searchResults.length; i++) {
    var result = searchResults[i];
    var tags = result.tags;
    if (tags && (tags.includes('is_sample') || tags.includes('no_search'))) {
      continue;
    }

    var pChecker = result.url;

    if (type == 'product') {
      var resultMarkup = `<div class="product"><a href="${result.url}">
      <div class="product__image-wrapper">
        <img
          itemprop="image"
          class="product__image product__image lazy"
          data-srcset="${result.image}"
          data-src="${result.image}"
          data-default-image="${result.image}"
          alt="${result.image} image"
        >
      </div>
      <div class="h3">${result.title}</div></a></div>`;

    } else {
      var resultMarkup = `<li><a href="${result.url}"><p class="">${result.title}</a></li>`;
    }
    $(parentWrapper).find('.js-list').append(resultMarkup);
  }
}
}

function getFullQueryCount(query){
// SEND A REQUEST TO THE SEARCH API FOR PRODUCTS, PAGES, AND ARTICLES THAT MATCH, OR ARE CLOSE TO MATCHING
$.getJSON("/search/suggest.json", {
  "q": query,
  "resources": {
    "type": "product,page,article",
    "options": {
      "fields": "title,product_type,variants.title,tag,variants.sku"
    }
  }
}).done(function(response) {
  // SHOPIFY SENDS BACK A RESPONSE WITH ANY RESULTS
  var results = response.resources.results;
  var productSuggestions = results.products;
  var pageSuggestions = results.pages;
  var articleSuggestions = results.articles;

  if (productSuggestions.length == 0 && pageSuggestions.length == 0 && articleSuggestions.length == 0) {
    $('.all-results-link').hide();
  } else {
    var queryLength = productSuggestions.length + pageSuggestions.length + articleSuggestions.length;
    $('.search-query').html(query);
    $('.search-results-count').html(queryLength);

    $('.all-results-link').show();

    $('.all-results-link').on("click", function(){
      window.location.href = "/search?q="+query;
    })
  }
});
}

function searchFormTerm (query) {
// SEND A REQUEST TO THE SEARCH API FOR PRODUCTS, PAGES, AND ARTICLES THAT MATCH, OR ARE CLOSE TO MATCHING
$.getJSON("/search/suggest.json", {
  "q": query,
  "resources": {
    "type": "product,page,article",
    "limit": 4,
    "options": {
      "unavailable_products": "last",
      "fields": "title,product_type,body,variants.title,tag,variants.sku"
    }
  }
}).done(function(response) {
  // SHOPIFY SENDS BACK A RESPONSE WITH ANY RESULTS
  var results = response.resources.results;
  var productSuggestions = results.products;
  var pageSuggestions = results.pages;
  // var articleSuggestions = [];
  var articleSuggestions = results.articles;
  resetSearchBar();

  if (productSuggestions.length == 0 && pageSuggestions.length == 0 && articleSuggestions.length == 0) {
    // var matchFound = checkForSynonyms(query);
    // var matchFoundTypo = checkForSynonyms(query);

    // if (matchFound == false) {
      showEmptySearchState(query);
      toggleSearchButton(false);
      checkForTypos(query);
      $('.all-results-link').hide();
    // }
  } else {
    $('.js-empty-state').hide();
    $('.js-results-list').show();

    showSearchResults(productSuggestions, '.js-results-products', 'product');
    showSearchResults(pageSuggestions, '.js-results-pages', 'page');
    showSearchResults(articleSuggestions, '.js-results-posts', 'article');
    // SHOW "VIEW ALL RESULTS" BUTTON
    toggleSearchButton(true);
  }

  showResultsDropdown();
});
}

$('.js-search').on('keyup', function () {
var query = $(this).val();

if (query.length) {
  // SHOW LOADING STATE
  searchFormTerm(query);
  getFullQueryCount(query);

} else {
  clearSearch();
}
});


let timer,
  timeoutVal = 1000; // time it takes to wait for user to stop typing in ms

const typer = document.getElementById('search-bar');

typer.addEventListener('keypress', handleKeyPress);
typer.addEventListener('keyup', handleKeyUp);

// when user is pressing down on keys, clear the timeout
function handleKeyPress(e) {
window.clearTimeout(timer);
}

// when the user has stopped pressing on keys, set the timeout
// if the user presses on keys before the timeout is reached, then this timeout is canceled
function handleKeyUp(e) {
window.clearTimeout(timer); // prevent errant multiple timeouts from being generated
timer = window.setTimeout(() => {
  var searchQuery = $(typer).val();
  // console.log(searchQuery)
  ga('send', 'event', 'Search', 'Typing', searchQuery);
}, timeoutVal);
}
